/**
 * Author   :   Dinushka Rukshan
 * Date     :   2020-07-22
 * Remark   :   https://developers.google.com/analytics/devguides/collection/gtagjs/events
 */
export const GtagEvent = ({ action, category, label }) => {
    window.gtag('event', action, {
        event_category: category,
        event_label: label
    })
};


export const AddItemToCartEvent = (item) => {
    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
        'event': 'addToCart',
        'ecommerce': {
            'currencyCode': 'LKR',
            'add': {
                'products': {
                    'name': item.itemName,
                    'id': item.itemID,
                    'price': item.amount,
                    'brand': '',
                    'category': item.departmentCode,
                    'variant': item.categoryCode,
                    'quantity': item.quantity,
                    'sku': item.itemCode
                }
            }
        }
    });
}

export const RemoveItemFromCartEvent = (item) => {
    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
        'event': 'removeFromCart',
        'ecommerce': {
            'currencyCode': 'LKR',
            'remove': {
                'products': {
                    'name': item.name,
                    'id': item.itemID,
                    'price': item.amount,
                    'brand': '',
                    'category': item.departmentCode,
                    'variant': item.categoryCode,
                    'quantity': item.quantity,
                    'sku': item.itemCode
                }
            }
        }
    });
}

export const OnCheckoutEvent = (items, paymentMethod) => {
    let itemsArr = [];
    items.map(elm => {
        itemsArr.push({
            'name': elm.itemName,
            'id': elm.itemID,
            'price': elm.amount,
            'brand': '',
            'category': elm.departmentCode,
            'variant': elm.categoryCode,
            'quantity': elm.quantity,
            'sku': elm.itemCode
        })
    })
    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    window.dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
            'checkout': {
                'actionField': { 'step': 1, 'option': paymentMethod },
                'products': [itemsArr]
            }
        },
        'eventCallback': function () {
            // document.location = 'checkout.html';
        }
    });
}

//GA4 Implementation
export const AddItemToCartEventGA4 = (item, outletCode) => {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
            currency: "LKR",
            value: item.discountedTotal,
            items: [
                {
                    item_id: item.itemCode,
                    item_name: item.itemName,
                    affiliation: item.merchantID,
                    coupon: "-",
                    currency: "LKR",
                    discount: item.discountValue,
                    index: 0,
                    item_brand: "-",
                    item_category: item.departmentCode,
                    item_category2: item.subDepartmentCode,
                    item_category3: item.categoryCode,
                    item_category4: "-",
                    item_category5: "-",
                    item_list_id: "-",
                    item_list_name: "-",
                    item_variant: "-",
                    location_id: outletCode,
                    price: item.amount,
                    quantity: item.quantity
                }
            ]
        }
    });
}

export const RemoveItemFromCartEventGA4 = (item, outletCode) => {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: "remove_from_cart",
        ecommerce: {
            currency: "LKR",
            value: item.discountedTotal,
            items: [
                {
                    item_id: item.itemCode,
                    item_name: item.itemName,
                    affiliation: item.merchantID,
                    coupon: "-",
                    currency: "LKR",
                    discount: item.discountValue,
                    index: 0,
                    item_brand: "-",
                    item_category: item.departmentCode,
                    item_category2: item.subDepartmentCode,
                    item_category3: item.categoryCode,
                    item_category4: "-",
                    item_category5: "-",
                    item_list_id: "-",
                    item_list_name: "-",
                    item_variant: "-",
                    location_id: outletCode,
                    price: item.amount,
                    quantity: item.quantity
                }
            ]
        }
    });
}

export const ViewCartEventGA4 = (items, outletCode, total) => {

    let itemsArr = [];
    items.map(item => {
        itemsArr.push({
            item_id: item.itemCode,
            item_name: item.itemName,
            affiliation: item.merchantID,
            coupon: "-",
            currency: "LKR",
            discount: item.discountValue,
            index: 0,
            item_brand: "-",
            item_category: item.departmentCode,
            item_category2: item.subDepartmentCode,
            item_category3: item.categoryCode,
            item_category4: "-",
            item_category5: "-",
            item_list_id: "-",
            item_list_name: "-",
            item_variant: "-",
            location_id: outletCode,
            price: item.amount,
            quantity: item.quantity
        })
    })

    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    window.dataLayer.push({
        event: "view_cart",
        ecommerce: {
            currency: "LKR",
            value: total,
            items: itemsArr
        }
    });
}

export const BeginCheckoutEventGA4 = (items, outletCode, total) => {

    let itemsArr = [];
    items.map(item => {
        itemsArr.push({
            item_id: item.itemCode,
            item_name: item.itemName,
            affiliation: item.merchantID,
            coupon: "-",
            currency: "LKR",
            discount: item.discountValue,
            index: 0,
            item_brand: "-",
            item_category: item.departmentCode,
            item_category2: item.subDepartmentCode,
            item_category3: item.categoryCode,
            item_category4: "-",
            item_category5: "-",
            item_list_id: "-",
            item_list_name: "-",
            item_variant: "-",
            location_id: outletCode,
            price: item.amount,
            quantity: item.quantity
        })
    })

    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    window.dataLayer.push({
        event: "begin_checkout",
        ecommerce: {
            currency: "LKR",
            value: total,
            items: itemsArr
        }
    });
}

export const AddPaymentInformationEventGA4 = (items, outletCode, total, currency, paymentMethod) => {

    let itemsArr = [];
    items.map(item => {
        itemsArr.push({
            item_id: item.itemCode,
            item_name: item.itemName,
            affiliation: item.merchantID,
            coupon: "-",
            currency: "LKR",
            discount: item.discountValue,
            index: 0,
            item_brand: "-",
            item_category: item.departmentCode,
            item_category2: item.subDepartmentCode,
            item_category3: item.categoryCode,
            item_category4: "-",
            item_category5: "-",
            item_list_id: "-",
            item_list_name: "-",
            item_variant: "-",
            location_id: outletCode,
            price: item.amount,
            quantity: item.quantity
        })
    })

    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    window.dataLayer.push({
        event: "add_payment_info",
        ecommerce: {
            currency: currency,
            value: total,
            coupon: "-",
            payment_type: paymentMethod,
            items: [itemsArr]
        }
    });
}

export const PurchaseEventGA4 = (items, outletCode, total, currency, orderNumber) => {

    let itemsArr = [];
    items.map(item => {
        itemsArr.push({
            item_id: item.itemCode,
            item_name: item.itemName,
            affiliation: item.merchantID,
            coupon: "-",
            //currency: "LKR",
            discount: item.discountValue,
            index: 0,
            item_brand: "-",
            item_category: item.departmentCode,
            item_category2: item.subDepartmentCode,
            item_category3: item.categoryCode,
            item_category4: "-",
            item_category5: "-",
            item_list_id: "-",
            item_list_name: "-",
            item_variant: "-",
            location_id: outletCode,
            price: item.amount,
            quantity: item.quantity
        })
    })

    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    window.dataLayer.push({
        event: "purchase",
        ecommerce: {
            transaction_id: orderNumber,
            //affiliation: "-",
            value: total,
            tax: 0,
            shipping: 0,
            currency: currency,
            coupon: "-",
            items: itemsArr
        }
    });
}

export const ProductDetailEventGA4 = (item) => {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: "view_item",
        ecommerce: {
            currency: "LKR",
            value: item.amount - item.discountValue,
            items: [
                {
                    item_id: item.itemCode,
                    item_name: item.name,
                    affiliation: item.merchantID,
                    coupon: "-",
                    currency: "LKR",
                    discount: item.discountValue,
                    index: 0,
                    item_brand: "-",
                    item_category: item.departmentCode,
                    item_category2: item.subDepartmentCode,
                    item_category3: item.categoryCode,
                    item_category4: "-",
                    item_category5: "-",
                    item_list_id: "-",
                    item_list_name: "-",
                    item_variant: "-",
                    price: item.amount,
                    quantity: 1,
                    stockinhand: item.stockInHand
                }
            ]   
        }
    });
}